import { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

export function CertificationNumberLabel({
  label,
  textColorClassName,
  textColorHoverClassName,
  className,
  isHover,
}) {
  const classes = [
    isHover === false && textColorClassName,
    isHover === true && textColorHoverClassName,
    className,
  ];

  return (
    <div
      className={clsx(
        'whitespace-nowrap font-sans transition duration-150 ease-in-out',
        classes
      )}
    >
      {label}
    </div>
  );
}

CertificationNumberLabel.defaultProps = {
  textColorClassName: 'text-gray-500',
  textColorHoverClassName: 'text-green-600',
  className: 'font-normal',
  isHover: false,
};

CertificationNumberLabel.propTypes = {
  label: PropTypes.node.isRequired,
  textColorClassName: PropTypes.string,
  textColorHoverClassName: PropTypes.string,
  className: PropTypes.string,
  isHover: PropTypes.bool,
};

export function CertificationNumberValue({ value, isHover }) {
  const classes = [
    isHover === true && 'text-green-500',
    isHover === false && 'text-gray-600',
  ];

  return (
    <p
      className={clsx(
        'mb-0 text-base font-medium transition duration-150 ease-in-out',
        classes
      )}
    >
      {value}
    </p>
  );
}

CertificationNumberValue.defaultProps = {
  isHover: false,
};

CertificationNumberValue.propTypes = {
  value: PropTypes.node.isRequired,
  isHover: PropTypes.bool,
};

export function CertificationNumberDivider({ isHover }) {
  const classes = [
    isHover === true && 'border-gray-300',
    isHover === false && 'border-gray-200',
  ];

  return (
    <div
      className={clsx(
        'flex-1 border-b-2 border-dashed transition duration-150 ease-in-out',
        classes
      )}
    />
  );
}

CertificationNumberDivider.defaultProps = {
  isHover: false,
};

CertificationNumberDivider.propTypes = {
  isHover: PropTypes.bool,
};

const defaultProps = {};

const propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node.isRequired,
};

export default function CertificationNumber({ label, value }) {
  const [isHover, setHover] = useState(false);

  return (
    <div
      className="flex w-full cursor-pointer items-center space-x-4 focus:outline-none"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      tabIndex="-1"
    >
      <CertificationNumberLabel label={label} isHover={isHover} />
      <CertificationNumberDivider isHover={isHover} />
      <CertificationNumberValue value={value} isHover={isHover} />
    </div>
  );
}

CertificationNumber.defaultProps = defaultProps;
CertificationNumber.propTypes = propTypes;
